import * as t from 'io-ts';
import { fromEnum } from '@bayer-int/portletce-shared';

import { Specification } from '.';

export enum SpecStatus {
    DEV = 'dev',
    REVIEW = 'review',
    RELEASED = 'released',
}

export enum DocumentType {
    PORTLET = 'portlet',
    VEGA_SPEC = 'vegaspec',
}

const PortletSpecificationWithMetadataC = t.type({
    id: t.string,
    json: Specification.codec,
    type: t.literal(DocumentType.PORTLET),
    text: t.string,
    author: t.string,
    namespaceId: t.union([t.string, t.null]),
    versionId: t.number,
    status: fromEnum<SpecStatus>(SpecStatus),
});

export type PortletSpecificationWithMetadata = t.TypeOf<typeof PortletSpecificationWithMetadataC>;
export const PortletSpecificationWithMetadata = { codec: PortletSpecificationWithMetadataC };

const PortletMetadataC = t.type({
    id: t.string,
    author: t.string,
    namespaceId: t.union([t.string, t.null]),
    versionId: t.number,
    status: fromEnum<SpecStatus>(SpecStatus),
});

export type PortletMetadata = t.TypeOf<typeof PortletMetadataC>;
export const PortletMetadata = { codec: PortletMetadataC };
